<template>
	<div class="page-dashboard" v-if="!!user">
		<div class="container-fluid">

			<!-- Table Menu -->
			<div class="table-menu flex-center">
				<div v-if="!smallScreen">
					<h2 class="text-primary mb-3">{{ $t(title) }}</h2>
					<div class="mb-4 pr-3">
						{{ $t('Create a list of your overlays, arrange and customize from existing predefined looks, to fit each streaming session') }}
					</div>
				</div>
				<div class="d-flex">
					<label
						v-if="!smallScreen"
						class="btn btn-default ml-a mr-2 mb-0 mw-fc">
						<div class="">
								<span>{{ $t('Import Rundown') }}</span>
								<input type="file" accept=".xlsx, .xls" class="hidden" @change="onImportSelected"/>
							</div>
					</label>
					<input
						type="text"
						class="form-control ml-a"
						:class="{'table-search': !smallScreen}"
						:placeholder="$t('Search')"
						@input="onKeywordChange"
						v-model="keyword"
					/>
					<div class="flex-center pointer" :style="filterStatus !== 'all' && filterStatus !== 'archive' ?  'min-width: 160px' : ''">
						<md-menu md-align-trigger md-direction="bottom-start">
							<div md-menu-trigger>
								<div class="flex-center pointer">
									<div class="mx-3" :class="`status-dot-${filterStatus}`"></div>
									<div class="mr-2">{{ formatStatus(filterStatus) }}</div>
									<div class="material-icons">expand_more</div>
								</div>
							</div>
							<md-menu-content id="scrolls-style">
								<md-menu-item class="item-property-rundown min-w150px" v-for="item in statusList" @click="rundownFilterUpdate(item.key)"
								:key="item.key">
									<div class="flex-center-left">
										<div class="mr-3" :class="`status-dot-${item.key}`"></div>
										{{item.label}}
									</div>
								</md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
				</div>
			</div>
			<div class="text-left" v-if="!isFetching && filteredAvailableItems.length === 0 && filteredAvailableItemsPinned.length === 0 && !keyword && !isCollaborator && filterStatus === 'all'">
				<button
					class="btn btn-primary mr-3 mb-5"
					@click="createQuickRundown()">
					{{$t('GET QUICK START RUNDOWN SAMPLE')}}
				</button>
			</div>
			<div class="text-center mt-3" v-if="items.length === 0 && keyword && filteredAvailableItems.length === 0 && filteredAvailableItemsPinned.length === 0 && !isFetching || filteredAvailableItems.length === 0 && filteredAvailableItemsPinned.length === 0 && !isFetching">
				<h4>{{ $t('It seems that the Rundown you are looking for isn\'t available') }}</h4>
			</div>
			<!-- Pinned Rundowns -->
			<div class="mb-5 text-center" v-if="isFetchingPinned && mode === 'pinned'">
				<div class="is-loading large"></div>
			</div>
			<div
				class=""
				v-if="mode === 'all' || mode === 'pinned'  && !isFetchingPinned">
				<div class="flex-center mb-3">
					<router-link v-if="pinnedItems.length > 0" to="/rundowns/pinned" class="text-white">
						<span>{{ $t('Pinned Rundown') }}</span>
					</router-link>
					<router-link to="/rundowns/pinned" class="text-white td-u ml-a" v-if="mode === 'all' && totalpinnedItems > 4">
						{{ $t('Show All') }}
					</router-link>
					<router-link to="/rundowns" class="text-white td-u ml-a" v-else-if="mode !== 'all'">
						{{ $t('Back') }}
					</router-link>
				</div>
				<div class="rundowns-container" v-if="pinnedItems.length > 0">
					<div class="rundowns-area">
						<div
							class="rundowns-item"
							v-for="(item, index) in pinnedItems"
							:key="index">
							<rundown-card
								:item="item"
								@duplicate="confirmDuplicateItem"
								@export="exportRundown(item,'excel')"
								@share="share"
								@pinned="pinned"
								@unpinned="pinned"
								@remove="confirmRemoveItem"
								@edit="confirmEdit"
								@sharedfolder="sharingMisc"
								@status="changeStatus"
							/>
						</div>
					</div>
				</div>
				<div class="text-center hidden" v-else>
					{{ $t('No Pinned Rundown available') }}
				</div>
				<!-- Table Pagination -->
				<pagination
					:current-page="pinnedPage"
					:total-pages="lastPinnedPage"
					@select="onPinnedPageSelected(...arguments)"
					v-if="mode !== 'all'">
				</pagination>
			</div>
			<!-- Recent Rundowns -->
			<div class="mb-5 text-center" v-if="isFetching">
				<div class="is-loading large"></div>
			</div>
			<div
				class="mb-extreme"
				v-if="mode === 'all' || mode === 'recent'">
				<div class="flex-center mb-3 mt-5">
					<router-link v-if="!isFetching && items.length !== 0 && !smallScreen" to="/rundowns/recent" class="text-white">
						{{ $t('Recent Rundown') }}
					</router-link>
					<router-link to="/rundowns/recent" class="text-white td-u ml-a" v-if="mode === 'all' && totalItems > 8 && !isFetching">
						{{ $t('Show All') }}
					</router-link>
					<router-link to="/rundowns" class="text-white td-u ml-a" v-else-if="mode!=='all'">
						{{ $t('Back') }}
					</router-link>
				</div>
				<div class="rundowns-container" v-if="filteredItems.length > 0">
					<div class="rundowns-area">
						<div
							class="rundowns-item"
							v-for="item in filteredItems"
							:key="item.id">
							<rundown-card
								v-if="items.length !== 0"
								:item="item"
								@duplicate="confirmDuplicateItem"
								@export="exportRundown(item,'excel')"
								@share="share"
								@pinned="pinned"
								@unpinned="pinned"
								@remove="confirmRemoveItem"
								@edit="confirmEdit"
								@sharedfolder="sharingMisc"
								@status="changeStatus"
							/>
						</div>
					</div>
				</div>
				<!-- Table Pagination -->
				<pagination
					:current-page="page"
					:total-pages="lastPage"
					@select="onPageSelected(...arguments)"
					v-if="mode !== 'all'">
				</pagination>
			</div>
		</div>

		<!-- Modals -->
		<div class="modals">
			<!-- User Form -->
			<user-form
				:data="selected"
				@saved="insertItem"
				@close="isFormVisible = false"
				v-if="isFormVisible"
			/>

			<!-- Duplicate Confirmation -->
			<modal
				size="small"
				@close="isConfirmDuplicateVisible = false"
				v-if="isConfirmDuplicateVisible">
				<template slot="header">
					<div>{{ $t('Confirm Duplicate') }}</div>
				</template>
				<template slot="body">
					{{ $t('Duplicate rundown') }} {{ showModalName(selected ? selected.name : '-') }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center m-0">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isDuplicating }"
							@click="duplicateItem(selected)">
							{{ $t('Yes, Proceed') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmDuplicateVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>

			<!-- Delete Confirmation -->
			<modal
				size="small"
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible">
				<template slot="header">
					{{ $t('Confirm Delete') }}
				</template>
				<template slot="body">
					<div class="text-white" v-if="selectedTotalAsset > 0">{{ $t(`There are ${selectedTotalAsset} assets in this rundown`) }}</div>
					<div>{{ $t('Are you sure want to delete') }} {{ showModalName(selected ? selected.name : '-') }}?</div>
				</template>
				<template slot="footer">
					<div class="w-100 flex-center" :class="{'mt-4': selectedTotalAsset > 0}">
						<button class="btn btn-primary" :class="{ 'is-loading': isRemoving }" @click="removeItem(selected)">
							{{ $t('Yes, Delete It') }}
						</button>
						<button class="btn btn-default" @click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>

			<!-- Share -->
			<modal
				size="small"
				@close="isShareVisible = false"
				v-if="isShareVisible">
				<template slot="header">
					{{ $t('Share Rundown') }}
				</template>
				<template slot="body">
					<social-share :url="shareUrl" />
				</template>
				<template slot="footer">
					<button
						class="btn btn-primary"
						@click="isShareVisible = false">
						{{ $t('OK') }}
					</button>
				</template>
			</modal>

			<!-- Shared folder Confirmation -->
			<modal
				size="small"
				@close="isConfirmSharedFolderVisible = false"
				v-if="isConfirmSharedFolderVisible">
				<template slot="header">
					{{ $t('Confirm Share Folder') }}
				</template>
				<template slot="body">
					<div>{{ $t('Are you sure want to share') }} {{ showModalName(selected ? selected.name : '-') }} {{ $t('folder') }}?</div>
				</template>
				<template slot="footer">
					<div class="w-100 flex-center" :class="{'mt-4': selectedTotalAsset > 0}">
						<button class="btn btn-primary" :class="{ 'is-loading': isSharing }" @click="sharingMisc(selected)">
							{{ $t('Yes') }}
						</button>
						<button class="btn btn-default" @click="isConfirmSharedFolderVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>

			<!-- Edit Rundown -->
			<modal
				size="small-medium"
				@close="isEditVisible = false"
				v-if="isEditVisible"
				>
				<template slot="header">
					{{ $t('Edit Rundown') }}
				</template>
				<template slot="body">
					<div class="form-group mb-3">
						<!-- name -->
						<label class="text-primary">{{ $t('Rundown Name') }}</label>
						<input
							type="text"
							class="form-control mb-4"
							v-model="rundownName"
						/>
						<!-- date time -->
						<div class="d-flex">
							<div style="width: 100%">
								<label class="text-primary">{{ $t('Date & Time') }}</label>
								<date-picker
									v-model="dateTime"
									:lang="lang"
									type="datetime"
									placeholder="Select datetime"
									:minute-step="30"
									:default-value="new Date().setHours(9, 0, 0, 0)"
									:disabled-date="notBeforeToday"
									format="DD/MM/YYYY HH:mm"
									valueType="YYYY-MM-DD HH:mm"
									:show-time-panel="showTimePanel"
									@close="handleOpenChange"
								>
									<template v-slot:footer>
									<button class="mx-btn mx-btn-text" @click="toggleTimePanel">
										{{ showTimePanel ? 'select date' : 'select time' }}
									</button>
									</template>
								</date-picker>
							</div>
							<div class="form-group select ml-2" style="width: 100%; max-height: 20px;">
								<label class="text-primary">Status</label>
								<div class="mh-40px">
									<multiselect class="select-input" v-model="status" deselect-label="Can't remove this value" track-by="label" label="label"
										placeholder=" " :options="filteredStatusList" :searchable="true" :allow-empty="false" :show-labels="false">
										<template slot="singleLabel" slot-scope="props">
											<div class="flex-center-left">
												<div :class="`status-dot-${props.option.key || 'pre_production'}`" class="mr-2"></div>
												<div class="option__desc">{{ props.option.label ? props.option.label : 'Pre Production' }}</div>
											</div>
										</template>
										<template slot="option" slot-scope="props">
											<div class="flex-center-left">
												<div :class="`status-dot-${props.option.key}`" class="mr-2"></div>
												<div class="option__desc">{{ props.option.label }}</div>
											</div>
										</template>
										<span class="arrow-multiselect" slot="caret">
											<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
										</span>
										<span slot="noResult">Oops! No package found.</span>
									</multiselect>
								</div>
							</div>
						</div>
						<!-- note -->
						<label class="text-primary mt-3">{{ $t('Notes') }}</label>
						<textarea type="text" name="note" rows="6" class="form-control" maxlength="455"
							v-model="description">
						</textarea>
					</div>
				</template>
				<template slot="footer">
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isSavingRundown }"
						:disabled="!rundownName || !dateTime"
						@click="updateRundown(selected)">
						{{ $t('Save') }}
					</button>
					<button
						type="button"
						class="btn btn-default"
						@click="isEditVisible = false">
						{{ $t('Cancel') }}
					</button>
				</template>
			</modal>
		</div>
		<modal-first-greeting v-if="userFirstLogin" :rundowns="items" @close="userSetLogin"></modal-first-greeting>
		<div v-for="item in userAssignePackage" :key="item.id">
			<modal-quotation-confirm v-if="item.is_active" @close="redirectToSubscribe" @declined="declineQuotation" :dataAssignePackage="item" ></modal-quotation-confirm>
		</div>
		<modal-rundown-take-over></modal-rundown-take-over>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import XLSX from 'xlsx';
import Modal from '@/components/Modal.vue';
import ModalRundownTakeOver from '@/components/ModalRundownTakeOver.vue';
import ModalFirstGreeting from '@/components/ModalFirstGreeting.vue';
import ModalQuotationConfirm from '@/components/ModalQuotationConfirm.vue';
import UserForm from '@/components/UserForm.vue';
import RundownCard from '@/components/RundownCard.vue';
import Pagination from '@/components/Pagination.vue';
import SocialShare from '@/components/SocialShare.vue';
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import dayjs from 'dayjs';

import {
	getAxiosErrorMessage, delay, share, duplicateVar, downloadBlob, elpisisString, copyToClipboard,
} from '@/lib/helper';
import rundownsApi from '@/api/rundowns';
import rundownItemsApi from '@/api/rundownItems';
import mediasApi from '@/api/medias';

import usersApi from '@/api/user';

import utc from 'dayjs/plugin/utc'; // import UTC plugin

dayjs.extend(utc);

export default {
	name: 'Rundowns',
	props: {
		mode: {
			type: String,
			default: 'all',
		},
	},
	components: {
		Modal,
		UserForm,
		RundownCard,
		ModalRundownTakeOver,
		ModalFirstGreeting,
		ModalQuotationConfirm,
		Pagination,
		SocialShare,
		Multiselect,
		DatePicker,
	},
	data() {
		return {
			page: 1,
			limit: 8,
			orderBy: 'created_at',
			sortBy: 'desc',
			keyword: '',
			role: 'client',
			isAll: false,
			items: [],
			lastPage: 1,
			selected: null,
			totalItems: 0,
			pinnedPage: 1,
			pinnedLimit: 4,
			pinnedOrderBy: 'created_at',
			pinnedSortBy: 'desc',
			totalpinnedItems: 0,
			lastPinnedPage: 1,
			pinnedIsAll: false,
			isFetchingPinned: false,
			roles: [
				{ key: 'all', label: 'All Roles' },
				{ key: 'client', label: 'Client' },
				{ key: 'super_admin', label: 'Super Admin' },
				{ key: 'collaborator', label: 'Collaborator' },
			],
			filterRole: null,
			isFormVisible: false,
			isConfirmRemoveVisible: false,
			isRemoving: false,
			title: 'Rundown',
			isConfirmDuplicateVisible: false,
			isExporting: false,
			pinnedItems: [],
			isShareVisible: false,
			isExportVisible: false,
			isArchiving: false,
			isDuplicating: false,
			userFirstLogin: false,
			isFetching: false,
			isImporting: false,
			isEditVisible: false,
			isSavingRundown: false,
			userAssignePackage: [],
			quickStarting: false,
			smallScreen: false,
			isConfirmSharedFolderVisible: false,
			isSharing: false,

			// edit rundown
			rundownName: '',
			description: '',
			status: '',
			dateTime: '',
			lang: {
				formatLocale: {
					firstDayOfWeek: 1,
				},
			},


			// filterstatus
			filterStatus: 'all',
			statusList: [
				{ key: 'all', label: 'All' },
				{ key: 'pre_production', label: 'Pre Production' },
				{ key: 'production', label: 'Production' },
				{ key: 'post_production', label: 'Post Production' },
				{ key: 'archive', label: 'Archive' },
			],

			// date picker
			showTimePanel: false,
		};
	},
	sockets: {
		// connect() {
		// },
		// rundown_update(payload) {
		// 	this.refetchUpdate();
		// 	this.nameRundown = payload.name;
		// },
	},
	methods: {
		onPageSelected(page) {
			this.fetch(true, page);
		},
		onPinnedPageSelected(page) {
			this.fetchPinned(true, page);
		},
		fetchData() {
			if (this.mode !== 'pinned') this.fetch(true, false);
			if (this.mode !== 'recent') this.fetchPinned(true);
		},
		toggleTimePanel() {
			this.showTimePanel = !this.showTimePanel;
			setTimeout(() => {
				const headline = document.getElementsByClassName('mx-time-header-title');
				headline[0].innerText = dayjs(headline[0].innerText).format('DD/MM/YYYY');
			}, 100);
		},
		handleOpenChange() {
			this.showTimePanel = false;
		},
		refetchUpdate() {
			const params = duplicateVar(this.fetchParams);
			params.is_pinned = false;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) this.isAll = true;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.insertItems(items);
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetching = false;
			};
			rundownsApi.getList(params, callback, errorCallback);
		},
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) this.page = page;
			const params = duplicateVar(this.fetchParams);
			if (this.filterStatus) params.status = this.filterStatus;
			params.is_pinned = false;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) this.isAll = true;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.insertItems(items);
				if (this.isFinance) this.$router.push('/billings');
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetching = false;
			};
			rundownsApi.getList(params, callback, errorCallback);
		},
		fetchPinned(reset = false, page) {
			this.isFetchingPinned = true;
			if (reset) {
				this.pinnedPage = 1;
				this.pinnedItems = [];
			}
			if (page) this.pinnedPage = page;
			const params = {
				page: this.pinnedPage,
				limit: this.pinnedLimit,
				order_by: this.pinnedOrderBy,
				sort_by: this.pinnedSortBy,
				user_id: this.user.id,
				is_pinned: true,
			};
			if (this.filterStatus) params.status = this.filterStatus;
			if (this.mode === 'pinned') params.limit = 8;
			if (this.keyword) params.keyword = this.keyword;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.pinnedLimit) this.pinnedIsAll = true;
				this.totalpinnedItems = response.total;
				this.lastPinnedPage = response.lastPage;
				this.insertItems(items);
				this.isFetchingPinned = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetchingPinned = false;
			};
			rundownsApi.getList(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				// this.fetch(true);
				this.fetchData(true);
			}, 500);
		},
		insertItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.items.push(item);
			} else {
				this.$set(this.items, index, item);
			}
		},
		addItem() {
			this.selected = null;
			this.isFormVisible = true;
		},
		editItem(item) {
			this.selected = item;
			this.isFormVisible = true;
		},
		confirmRemoveItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		confirmDuplicateItem(item) {
			this.selected = item;
			this.isConfirmDuplicateVisible = true;
		},
		confirmExportItem(item) {
			this.selected = item;
			this.isExportVisible = true;
		},
		confirmEdit(item) {
			this.rundownName = item.name;
			let formatDate = null;
			formatDate = dayjs.utc(item.start_time).format('YYYY-MM-DD HH:mm');
			this.dateTime = formatDate;
			const indexStatus = this.filteredStatusList.findIndex(({ key }) => key === item.status);
			if (indexStatus !== -1) {
				this.status = this.filteredStatusList[indexStatus];
			} else {
				this.status = { key: 'pre_production', label: 'Pre Production' };
			}
			this.description = item.description;
			this.selected = item;
			this.isEditVisible = true;
		},
		confirmSharedFolderItem(item) {
			this.selected = item;
			this.isConfirmSharedFolderVisible = true;
		},
		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const message = response.message;
				if (item.is_pinned) {
					const index = this.pinnedItems.findIndex(({ id }) => id === item.id);
					if (index !== -1) {
						this.pinnedItems.splice(index, 1);
					}
				} else {
					const index = this.items.findIndex(({ id }) => id === item.id);
					if (index !== -1) {
						this.items.splice(index, 1);
					}
				}
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove Rundown',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isRemoving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove Rundown',
					text: message,
				});
			};
			rundownsApi.delete(item.id, callback, errorCallback);
		},
		pinned(item, value) {
			this.isArchiving = true;
			const params = {
				is_pinned: value,
			};
			const callback = (response) => {
				const message = response.message;
				const data = response.data;
				if (value) {
					const index = this.items.findIndex(({ id }) => id === item.id);
					if (index !== -1) {
						this.items.splice(index, 1);
						this.pinnedItems.push(data);
					}
				} else {
					const index = this.pinnedItems.findIndex(({ id }) => id === item.id);
					if (index !== -1) {
						this.pinnedItems.splice(index, 1);
						this.items.push(data);
					}
				}
				this.fetchData();
				this.isArchiving = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Pinned Rundown',
					text: message,
				});
				// this.fetchData();
			};
			const errorCallback = (e) => {
				this.isArchiving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Pinned Rundown',
					text: message,
				});
			};
			rundownsApi.update(item.id, params, callback, errorCallback);
		},
		duplicateItem(item) {
			this.isDuplicating = true;
			// const name = `Duplicate of ${item.name}`;
			const callback = (response) => {
				const duplicatedItem = response.data;
				const message = response.message;
				// this.insertItems([duplicatedItem]);
				this.items.push(duplicatedItem);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Duplicate Rundown',
					text: message,
				});
				if (item.is_pinned && this.mode !== 'pinned') this.fetchPinned(true);
				if (item.is_pinned && this.mode === 'pinned') this.fetchPinned();
				if (!item.is_pinned && this.mode !== 'recent') this.fetch(true);
				if (!item.is_pinned && this.mode === 'recent') this.fetch();
				this.isDuplicating = false;
				this.isConfirmDuplicateVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Duplicate Rundown',
					text: message,
				});
				this.isDuplicating = false;
			};
			rundownsApi.duplicate(item.id, callback, errorCallback);
		},
		share(item) {
			this.selected = item;
			const origin = window.location.origin;
			const url = `${origin}/rundowns/editor/${atob(item.slug)}`;
			if (navigator.share) {
				const payload = {
					title: 'Grafias',
					text: `Rundown ${item.name}`,
					url,
				};
				share(payload);
			} else {
				this.isShareVisible = true;
			}
		},
		exportRundown(item, type) { // get from backend because we dont have the data on the front end side
			this.isExporting = true;
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				ids: JSON.stringify([item.id]),
			};
			const callback = (response) => {
				const contents = response;
				downloadBlob(contents, { name: item.name, type });
				this.isExporting = false;
			};
			const errorCallback = () => {
				this.isExporting = false;
			};
			rundownsApi.exportList(type, params, callback, errorCallback);
		},
		createQuickRundown() {
			this.quickStarting = false;
			const callback = () => {
				this.fetch();
				this.quickStarting = false;
			};
			const errorCallback = () => {
				this.quickStarting = false;
			};
			rundownsApi.quickStartRundown(callback, errorCallback);
		},
		onImportSelected(e) {
			const files = e.target.files;
			if (files.length > 0) {
				if (files[0].name.includes('.xlsx') || files[0].name.includes('.xls')) {
					const file = files[0];
					const reader = new FileReader();
					reader.onload = (e) => {
						const data = e.target.result;
						try {
							const workbook = XLSX.read(data, {
								type: 'binary',
							});
							workbook.SheetNames.forEach((sheetName) => {
								// Here is your object
								const XlRowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
								this.create(sheetName, XlRowObject);
							});
						} catch (error) {
							this.$notify({
								group: 'app',
								type: 'warning',
								title: 'Upload Media',
								text: 'File Corrupt, cannot read data',
							});
						}
					};
					// eslint-disable-next-line no-unused-vars
					reader.onerror = (ex) => {
					};
					reader.readAsBinaryString(file);
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		createBulkRundownItem(id, items) {
			this.isImporting = true;
			const rundownId = id;
			const callback = () => {
				this.fetch();
				// const importedItems = response.data;
				// this.insertItems(importedItems);
				this.isImporting = false;
				const message = this.$t('Import Success');
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Rundown Assets',
					text: message,
				});
			};
			const errorCallback = () => {
				this.isImporting = false;
			};
			rundownItemsApi.createBulk(rundownId, items, callback, errorCallback);
		},
		create(name, items) {
			this.isImporting = true;
			const callback = (response) => {
				const item = response.data;
				this.insertItems([item]);
				this.createBulkRundownItem(item.id, items);
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Import Rundowns',
					text: message,
				});
				// this.isImporting = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Import Rundowns',
					text: message,
				});
				this.isImporting = false;
			};
			const params = {
				name,
			};
			rundownsApi.create(params, callback, errorCallback);
		},
		updateRundown(item) {
			this.isSavingRundown = true;
			const callback = (response) => {
				const itemRundown = response.data;

				// eslint-disable-next-line
				item.name = itemRundown.name;
				item.description = itemRundown.description;
				item.start_time = itemRundown.start_time;
				item.status = itemRundown.status;

				if (item.is_pinned) {
					const index = this.pinnedItems.findIndex(({ id }) => id === item.id);
					this.pinnedItems[index].slug = itemRundown.slug;
				} else {
					const index = this.items.findIndex(({ id }) => id === item.id);
					this.items[index].slug = itemRundown.slug;
				}
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Rundown has been updated',
					text: 'Rundown has been updated',
				});
				this.isSavingRundown = false;
				this.isEditVisible = false;
			};
			const errorCallback = () => {
				this.isSavingRundown = false;
				this.isEditVisible = false;
			};
			const params = {
				name: this.rundownName,
				description: this.description,
				status: this.status,
				start_time: this.dateTime,
			};
			if (this.status && this.status.key) params.status = this.status.key;
			rundownsApi.update(item.id, params, callback, errorCallback);
		},
		insertItems(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				if (item.is_pinned) {
					const index = items.findIndex(({ id }) => id === item.id);
					if (index === -1) {
						this.pinnedItems.push(item);
					} else {
						this.$set(this.pinnedItems, index, item);
					}
				} else {
					const index = items.findIndex(({ id }) => id === item.id);
					if (index === -1) {
						this.items.push(item);
					} else {
						this.$set(this.items, index, item);
					}
				}
				// }
			}
		},
		userSetLogin() {
			const callback = (response) => {
				const items = response.data;
				this.userFirstLogin = items.is_first_time_login;
				this.userAssignePackage = items.assignPackages;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
			};
			usersApi.get(this.user.id, callback, errorCallback);
		},
		showModalName(str) {
			return elpisisString(str);
		},
		redirectToSubscribe(packageId) {
			const callback = (response) => {
				this.userAssignePackage = response.data.assignPackages;
				this.$router.push(`/settings?menu=payment&packageId=${packageId}`);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
			};
			usersApi.get(this.user.id, callback, errorCallback);
		},
		declineQuotation() {
			const callback = (response) => {
				this.userAssignePackage = response.data.assignPackages;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
			};
			usersApi.get(this.user.id, callback, errorCallback);
		},
		onResizeWidth() {
			if (window.innerWidth <= 1024) {
				this.smallScreen = true;
			} else {
				this.smallScreen = false;
			}
		},

		// shared folder
		sharingMisc(item) {
			this.isSharing = true;
			const callback = (response) => {
				const item = response.data;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Media',
					text: response.message,
				});
				copyToClipboard(item);
				this.isSharing = false;
				this.isConfirmSharedFolderVisible = false;
				this.selected = null;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isConfirmSharedFolderVisible = false;
			};
			mediasApi.generateUrl(item.id, callback, errorCallback);
		},

		changeStatus(item, status) {
			this.isChangeStatus = true;
			const params = {
				status,
			};
			const callback = (response) => {
				const message = response.message;
				if (item.is_pinned) {
					const index = this.pinnedItems.findIndex(({ id }) => id === item.id);
					this.pinnedItems[index].status = status;
				} else {
					const index = this.items.findIndex(({ id }) => id === item.id);
					this.items[index].status = status;
				}
				this.isChangeStatus = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Pinned Rundown',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isChangeStatus = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Pinned Rundown',
					text: message,
				});
			};
			rundownsApi.update(item.id, params, callback, errorCallback);
		},

		rundownFilterUpdate(status) {
			this.filterStatus = status;
			this.fetchData(true);
		},

		formatStatus(status) {
			return status.replace(/\b\w/g, (match) => match.toUpperCase()).replace('_', ' '); // Replace underscores with space
		},

		notBeforeToday(date) {
			return date < new Date(new Date().setHours(0, 0, 0, 0));
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isCollaborator: 'isCollaborator',
			isFinance: 'isFinance',
		}),
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				user_id: this.user.id,
				// role: this.role,
			};
			const keyword = this.keyword.trim();
			if (keyword !== '') params.keyword = keyword;
			return params;
		},
		filteredItems() {
			const filtered = this.items.filter(item => !item.is_pinned);
			return filtered;
		},
		filteredAvailableItems() {
			const filtered = this.items.filter(item => !item.is_disabled);
			return filtered;
		},
		filteredAvailableItemsPinned() {
			const filtered = this.pinnedItems.filter(item => !item.is_disabled);
			return filtered;
		},
		shareUrl() {
			return this.selected ? `${window.location.origin}/rundowns/${atob(this.selected.slug)}` : '';
		},
		activeUsers() {
			const activeUsers = this.items && this.items.activeUsers !== '' ? JSON.parse(this.items.activeUsers) : null;
			return activeUsers;
		},
		selectedTotalAsset() {
			const total = this.selected && this.selected.__meta__ ? this.selected.__meta__.rundownItems_count : 0;
			return total;
		},
		filteredStatusList() {
			const status = duplicateVar(this.statusList);
			const newArray = status.slice();
			newArray.shift();
			return newArray;
		},
	},
	created() {
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
		if (this.user) {
			// const userId = this.user && this.user.id ? this.user.id : '';
			// const roomId = `user_${userId}`;
			// this.$socket.client.emit('join', roomId);
			this.fetchData(true);
			this.userSetLogin();
		}
	},
	// beforeDestroy() {
	// 	this.leaveSocket();
	// },
	mounted() {
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
	},
	watch: {
		user(newUser, oldUser) {
			if (!oldUser || (newUser.settings === oldUser.settings)) {
				this.fetchData();
			}
			this.userSetLogin();
		},
		mode() {
			this.fetchData();
		},
		rundownName(val) {
			this.rundownName = val.replace(/[^A-Z0-9 ]/gi, '');
		},
	},
};
</script>
